export const PRE_VERIFICATION_PHONE_KEY = "pre_verification_phone";

export const PRE_REGISTRATION_NUDGE_KEY = "pre_registration_show_nudge";
export const PRE_REGISTRATION_NUDGE_BANK_KEY =
  "pre_registration_show_bank_nudge";
export const PRE_REGISTRATION_EARLY_BONUS_ACK_KEY =
  "pre_registration_early_bonus_ack";

export const PRE_REGISTRATION_REGION = "kansai" as const;

export const PRE_REGISTRATION_INCENTIVE = {
  amount: 3000,
  giftLabel: "Amazonギフト券",
  preRegistrationCondition: "SMS認証完了",
  fullCondition: "初回勤務完了",
  payoutTiming: "初回勤務完了の翌月末",
} as const;

export const PRE_REGISTRATION_EARLY_BONUS = {
  amount: 500,
  giftLabel: "Amazonギフト券",
  deadlineLabel: "7月31日",
  condition: "本人確認・給与受取口座の登録完了",
} as const;

export const PRE_REGISTRATION_COPY = {
  pageTitle: "事前登録",
  pageDescription:
    "SMS認証で事前登録が完了しています。プロフィール・本人確認・給与受取口座で応募準備を進めましょう。",
  smsPageDescription: "まずはSMS認証で登録を始めましょう",
  smsCompleteCta: "認証する",
  smsStepMicroCopy:
    "SMS認証完了で事前登録完了。7月31日までに本人確認・口座登録でAmazonギフト券500円分をプレゼント！",
  regionBadge: "関西版",
  serviceStartSchedule: "8月に開始予定",
  optionalBenefitsTitle: "応募準備でサービス開始後すぐ働けます",
  optionalBenefitsBody:
    "SMS認証で事前登録は完了しています。プロフィール・本人確認・給与受取口座もあわせて登録いただくと、サービス開始後すぐに応募・勤務・給与の受け取りが可能になります。",
  profileCompleteNudgeTitle: "プロフィールの保存が完了しました",
  profileCompleteNudgeBody:
    "7月31日までに本人確認と給与受取口座を登録すると、Amazonギフト券500円分をプレゼント！（所要約8分）",
  bankCompleteNudgeTitle: "本人確認書類を提出しました",
  bankCompleteNudgeBody:
    "審査完了をお待ちください。給与受取口座も登録しておくと、500円特典の対象になります（所要約3分）。",
  footerRecommendHint:
    "7月31日までに本人確認・給与受取口座を登録するとAmazonギフト券500円分をプレゼント",
  skipConfirmTitle: "完了画面へ進みますか？",
  skipConfirmBody:
    "SMS認証で事前登録は完了しています。以下の項目が未登録のため、サービス開始後すぐに応募するには追加登録をおすすめします。",
  skipConfirmProceed: "完了画面へ進む",
  footerCompleteCta: "完了画面へ",
  footerFullyPreparedCta: "登録完了画面へ",
  footerIdentificationReviewingTitle: "本人確認を審査中です",
  footerIdentificationReviewingBody:
    "承認後に応募準備が完了し、完了画面へ進めます。",
  incentiveBannerTitle: "事前登録＆初回勤務完了で",
  earlyBonusBannerTitle: "7月31日までの早期登録ボーナス",
  earlyBonusBannerSubtitle: "本人確認・給与受取口座の登録完了で",
  earlyBonusCompleteMainBodyLead: "応募準備の登録完了で全員に",
  earlyBonusCompleteMainBodyHighlight: "Amazonギフト券500円！！",
  earlyBonusCompleteSubCopy:
    "7月31日までにプロフィール、本人確認、給与受取口座の登録完了すると全員にAmazonギフト券500円プレゼント",
  earlyBonusAchievedMicroCopy:
    "早期登録ボーナスの条件を満たしました。特典は別途ご連絡します。",
  earlyBonusPendingMicroCopy:
    "7月31日までに本人確認・給与受取口座を登録すると、Amazonギフト券500円分をプレゼント！",
  earlyBonusModalTitle: "早期登録ボーナスのご案内",
  earlyBonusModalConfirm: "内容を確認しました",
  completeHeroNote: "ご登録ありがとうございます。詳細はSMSでご連絡します。",
  fullyPreparedCompleteHeroTitle: "すべての準備が整いました！",
  fullyPreparedCompleteHeroNote:
    "プロフィール・本人確認・給与受取口座の登録が完了しました。サービス開始後すぐに応募できます。",
  fullyPreparedCloseInstructionTitle: "以上で登録は完了です",
  allCompleteHeroBadge: "応募準備完了",
  allCompleteHeroSubtitle: "サービス開始後すぐに応募できます",
  allCompleteNextStepsTitle: "サービス開始までの流れ",
  allCompleteReadyStepLabel: "プロフィール・本人確認・口座 — 準備完了",
  allCompleteIncentiveTimelineTitle: "獲得予定の特典",
  allCompleteEarlyBonusTimelineLabel:
    "早期登録ボーナス（本人確認・口座登録完了）",
  allCompleteMainIncentiveTimelineLabel: "事前登録＆初回勤務完了ボーナス",
  continueRegistrationCta: "応募準備に進む",
  progressCaption:
    "SMS認証で事前登録完了 · プロフィール・本人確認・給与受取口座で応募準備",
  alreadyRegisteredModalTitle: "すでにケアリンクに登録済みです",
  alreadyRegisteredModalBody:
    "この電話番号は本登録済みのアカウントです。求人の閲覧・応募は通常のログイン画面からご利用ください。",
  alreadyRegisteredModalCta: "求人を見る",
  alreadyRegisteredModalCtaSignup: "ログイン画面へ",
  alreadyRegisteredModalCtaWithdrawn: "マイページへ",
} as const;

export type PreRegistrationMainView =
  | "portal"
  | "profile"
  | "identification"
  | "bankAccount";

export const PRE_REGISTRATION_VIEW_PARAM = "view";

export function preRegistrationPortalUrl(
  view?: Exclude<PreRegistrationMainView, "portal">,
): string {
  if (!view) return "/pre_registration";
  return `/pre_registration?${PRE_REGISTRATION_VIEW_PARAM}=${view}`;
}

export function parsePreRegistrationView(
  value: string | null,
): PreRegistrationMainView | null {
  if (
    value === "profile" ||
    value === "identification" ||
    value === "bankAccount"
  ) {
    return value;
  }
  return null;
}

export function getRecommendedStepLabel(
  view: Exclude<PreRegistrationMainView, "portal">,
): string {
  switch (view) {
    case "profile":
      return "プロフィールを登録する";
    case "identification":
      return "本人確認を登録する（約5分）";
    case "bankAccount":
      return "給与受取口座を登録する（約3分）";
  }
}

export const PRE_REGISTRATION_SUB_VIEW_TITLES: Record<
  Exclude<PreRegistrationMainView, "portal">,
  string
> = {
  profile: "プロフィール入力",
  identification: "本人確認",
  bankAccount: "給与受取口座",
};

export const PRE_REGISTRATION_IDENTIFICATION_PLAN_TITLE =
  "本人確認書類提出" as const;

export type PreRegistrationHeaderMode = "logo" | "subView";

export function getPreRegistrationHeaderConfig(
  pathname: string,
  viewParam: string | null,
): {
  mode: PreRegistrationHeaderMode;
  title?: string;
  backHref?: string;
} {
  const planMatch = pathname.match(
    /^\/pre_registration\/identification\/([^/]+)$/,
  );
  if (planMatch) {
    return {
      mode: "subView",
      title: PRE_REGISTRATION_IDENTIFICATION_PLAN_TITLE,
      backHref: preRegistrationPortalUrl("identification"),
    };
  }

  const parsedView = parsePreRegistrationView(viewParam);
  if (parsedView && parsedView !== "portal") {
    return {
      mode: "subView",
      title: PRE_REGISTRATION_SUB_VIEW_TITLES[parsedView],
      backHref: "/pre_registration",
    };
  }

  return { mode: "logo" };
}

export const PRE_REGISTRATION_SMS_COMPLETE_PATH =
  "/pre_registration/complete" as const;

export const PRE_REGISTRATION_FULLY_PREPARED_COMPLETE_PATH =
  "/pre_registration/complete/fully_prepared" as const;
